/* eslint-disable import/no-named-as-default */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router';
import { useForm } from 'react-hook-form';
// import _ from 'lodash';

import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error } from '../../components/Error';
import { BackButton } from '../../components/Button';
import { DeliveryOrderForm } from '../../components/Forms';
import { CONFIG } from '../../utils/constants';

const EditDeliveryOrder = ({ title, subtitle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const job = useSelector((state) => state.job);
  const container = useSelector((state) => state.container);
  const deliveryOrders = useSelector((state) => state.deliveryOrders);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({});

  const [selectJob, setSelectJob] = useState();

  useEffect(() => {
    dispatch(actions.deliveryOrderGet(params?.id));
    dispatch(actions.jobAll({ page: 1, size: CONFIG.infiniteLimit }));
    dispatch(actions.containerAll({ page: 1, size: CONFIG.infiniteLimit }));
    return () => {};
  }, []);

  useEffect(() => {
    if (deliveryOrders) {
      setValue('job', deliveryOrders?.job);
    }
    return () => {};
  }, [deliveryOrders]);

  const handleCreateJob = () => {
    history.push('/jms/job');
  };

  const handleCreateContainer = async (data) => {
    try {
      await dispatch(actions.containerCreate(data));
      await dispatch(
        actions.containerAll({ page: 1, size: CONFIG.infiniteLimit }),
      );
    } catch (error) {
      alert(`สร้างตู้คอนเทนเนอร์ไม่สำเร็จ ${error?.message}`);
    }
  };

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        job: data?.job?._id ? data?.job?._id : data?.job,
        price: data?.price,
        weight: data?.weight,
        amount: data?.amount,
      };
      await dispatch(actions.deliveryOrderPut(params?.id, payload));
      await dispatch(actions.deliveryOrderAll({ name: '', page: 1, size: 1 }));
      window.alert('แก้ไขคำสั่งจัดส่งสำเร็จ');
      history.push('/tms/delivery-order');
    } catch (error) {
      window.alert('แก้ไขคำสั่งจัดส่งไม่สำเร็จ', error?.message);
      // eslint-disable-next-line no-undef
      console.error('Create Manufacturing Order Fail', err);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const renderButton = () => (
    <div className="flex justify-start pb-4">
      <BackButton />
    </div>
  );

  const renderForm = () => (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DeliveryOrderForm
          control={control}
          errors={errors}
          container={container}
          job={job}
          selectJob={selectJob}
          setSelectJob={setSelectJob}
          handleCreateJob={handleCreateJob}
          handleCreateContainer={handleCreateContainer}
          setValue={setValue}
          watch={watch}
          deliveryOrder={deliveryOrders}
        />
        <div className="flex justify-end my-2">
          <Button variant="contained" type="submit">
            บันทึก
          </Button>
        </div>
      </form>
    </div>
  );

  if (job.isLoading) {
    return <Loading />;
  }

  if (
    !job.isLoading &&
    job.isCompleted &&
    !deliveryOrders?.isLoading &&
    deliveryOrders?.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        {renderButton()}
        {renderForm()}
      </div>
    );
  }
  return <Error />;
};

EditDeliveryOrder.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditDeliveryOrder.defaultProps = {
  title: '',
  subtitle: '',
};

export default EditDeliveryOrder;
